import requestv2 from "~/utils/http-v2";

const candidateApi = {
	gets : async (params) => {
		const url = 'v2/candidate';
		return await requestv2.get(url, {params});
	},
	add : async (params) => {
		const url = 'v2/candidate';
		return await requestv2.post(url, params);
	},
	addSheet : async (params) => {
		const url = 'v2/candidate/add-sheet';
		return await requestv2.post(url, params);
	},
	update : async (params) => {
		const url = `v2/candidate/${params.id}`;
		return await requestv2.patch(url, params);
	},
	delete : async (id) => {
		const url = `v2/candidate/${id}`;
		return await requestv2.delete(url);
	},
	toggleSentEmail : async (id, status) =>
	{
		const url = `v2/candidate/toggle-sent-email/${id}`;
		return await requestv2.post(url, {status});
	},
	toggleTraining : async (id, status) =>
	{
		const url = `v2/candidate/toggle-training/${id}`;
		return await requestv2.post(url, {status});
	},
};

export default candidateApi;